module.exports = __webpack_public_path__ + "images/google-pay.7638546744db7f77d7de51be231173d7.svg";